module.exports = __webpack_public_path__ + "img/1.ec6b97bb.png";